import React from 'react';
import './App.css';
import { useState } from 'react';

import { GoogleMap, withGoogleMap, withScriptjs, } from "react-google-maps"


import { collection, query, getDocs } from "firebase/firestore";
import { db } from './firebase.js'

import image from "./MarkerLogo.png";

import cafe from "./markers/Cafés.png";
import hotel from "./markers/Eco Hotels.png"
import fairfashion from "./markers/Fair Fashion.png"
import Nachhaltige from "./markers/Nachhaltige Aktivitäten.png"
import Naturkosmetik from "./markers/Naturkosmetik.png"
import Resturent from "./markers/Restaurants.png"
import Unverpackt from "./markers/Unverpackt Läden.png"


import Mappoints from "./mappoints"

const styles = require('./googlemapstyles.json')


let iconimg = { image }

let marker = [{
  id: 1,
  latitude: 48.0401388081653,
  longitude: 11.523255328834987,
  shelter: 'Marker 1',
  images: "https://7wallpapers.net/wp-content/uploads/20_Venice.jpeg",
  details: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"

},]

let lat = 48.0401388081653;
let long = 11.523255328834987;



const MyMapComponent = withScriptjs(withGoogleMap((props) => {
  console.log(marker.length);


  return (
    <GoogleMap
      defaultZoom={10}
      center={{ lat: lat, lng: long }}
      defaultOptions={{
        disableDefaultUI: true, // disable default map UI
        draggable: true, // make map draggable
        keyboardShortcuts: false, // disable keyboard shortcuts
        scaleControl: true, // allow scale controle
        scrollwheel: true, // allow scroll wheel
        styles: styles // change default map styles
      }}
    >

      {

        marker.length > 1 ? (marker.map(marker => {
          return (
            <Mappoints marker={marker} icon={iconimg} />
          )
        })) : null}
    </GoogleMap>
  )
}



))




function App() {


  const [those, setthose] = useState("")



  async function fashionStore(img, col) {

    console.log(marker.length)

    iconimg = img

    const q = query(collection(db, col));
    let mark = []

    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      mark.push(doc.data())
      console.log(doc.id, " => ", doc.data());
    });


    marker = mark

    setthose(Math.random())
    setthose(col)
    setthose("hello2")
    setthose("hello6" + Math.random())

  }

  let cor = [
    { lat: 52.52155661869433, long: 13.378007005329954 },
    { lat: 48.15070281809498, long: 11.56448596715385 },
    { lat: 50.11364284638218, long: 8.653034538712268 },
    { lat: 48.788625245625234, long: 9.17514628418819 },
    { lat: 50.95156348457133, long: 6.981733291814562 },
    { lat: 53.53703007161079, long: 10.014306743366445 },
  ]

  function city(v) {
    lat = cor[v].lat
    long = cor[v].long


    setthose(Math.random())
    setthose(v)
    setthose("hello2")
    setthose("hello6" + Math.random())

  }

  return (
    <div className={"App"}>

      {/* <select className={"select"} onChange={(e) => fashionStore(image, e.target.value)}>
        <option value="" disabled selected hidden>Kategorie auswählen</option>
        <option value="fashionStore">Fair Fashion Stores</option>
        <option value="naturkosmetik">Naturkosmetik Stores</option>
        <option value="restaurants">Restaurants</option>
        <option value="cafes">Cafés</option>
        <option value="unverpackt">Unverpackt-Läden</option>
        <option value="nachhaltige">Nachhaltige Aktivitäten</option>
        <option value="hotels">Hotels</option>
      </select> */}

      <div className='input-wrapper'> 
      <select className={"select"} onChange={(e) => city(e.target.value)}>
        <option value="" disabled selected hidden>Stadt auswählen</option>
        <option value="0">Berlin</option>
        <option value="1">München</option>
        <option value="2">Frankfurt</option>
        <option value="3">Stuttgart</option>
        <option value="4">Köln</option>
        <option value="5">Hamburg</option>

      </select>

      <div className='title'>
          <span>Kategorien</span>
      </div>

      <div className='button-wrapper'>
        <button className='button' onClick={(e) => fashionStore(fairfashion, "fashionStore")}>
          Fair Fashion Stores
        </button>
        <button className='button' onClick={(e) => fashionStore(Naturkosmetik, "naturkosmetik")}>
          Naturkosmetik Stores
        </button>
        <button className='button' onClick={(e) => fashionStore(hotel, "hotels")}>
          Eco Hotels
        </button>
        <button className='button' onClick={(e) => fashionStore(Resturent, "restaurants")}>
          Vegane Restaurants
        </button>
        <button className='button' onClick={(e) => fashionStore(cafe, "cafes")}>
          Vegane Cafés
        </button>
        <button className='button' onClick={(e) => fashionStore(Unverpackt, "unverpackt")}>
          Unverpackt-Läden
        </button>
        <button className='button' onClick={(e) => fashionStore(Nachhaltige, "nachhaltige")}>
          Nachhaltige Aktivitäten
        </button>
      </div>

      </div>


      <MyMapComponent
        className={"map"}
        isMarkerShown
        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAdEZrgGRby3wYnzFvq9QvGdyvcei_1rys&v=3.exp&libraries=geometry,drawing,places"
        loadingElement={<div style={{ height: `80%`, width: "80%" }} />}
        containerElement={<div style={{ height: `72vh` }} />}
        mapElement={<div style={{ height: `100%` }} />}
      />

    </div>
  )
}



export default App;
